import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharePopupComponent } from './share-popup.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { DialogModule } from 'primeng/dialog';
import {ShareIconsModule} from 'ngx-sharebuttons/icons';



@NgModule({
  declarations: [SharePopupComponent],
  imports: [
    CommonModule,
     ShareButtonsModule.withConfig({
          debug:true
        }), 
        DialogModule,
        ShareIconsModule
        
  ],
  exports:[SharePopupComponent]
})
export class SharePopupModule { }
